// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root___-FL3","title":"InfoRow_title__3OQCM"};